import { styled } from '@mui/system';
import { Typography, Box, Switch } from '@mui/material';

export const SwitchStyled = styled(Switch)(({ theme }) => ({
  width: '70px',
  height: '1.75rem',
  borderRadius: '100px',
  fontFamily: 'BGBold',
  padding: 0,
  '& .Mui-checked': {
    transform: 'translateX(2.5rem) !important',
    color: `${theme.palette.common.white} !important`
  },
  '& .Mui-checked+.MuiSwitch-track': {
    backgroundColor: `${theme.palette.primaryDark} !important`,
    opacity: '1 !important',
    '&::before': {
      content: '"YES"',
      left: 12,
      color: theme.palette.common.white
    },
    '&::after': {
      content: '""'
    }
  },
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '40%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16
    },
    '&::after': {
      content: '"NO"',
      right: 17,
      color: theme.palette.common.white
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 15,
    height: 15,
    margin: -2
  }
}));

export const HenryOxfordIcon = styled(Box)(({ theme }) => ({
  width: '45px',
  height: '45px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '0.3125rem solid #f2f2f2',
  position: 'relative',
  top: '1.875rem'
}));

export const SelectionTitleStyled = styled(Typography)(({ theme }) => ({
  width: '90%',
  fontWeight: 400,
  color: theme.palette.primaryDark,
  fontFamily: 'Calibri',
  lineHeight: '1.25rem',
  fontSize: '1rem'
}));

export const SelectionBoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '0.9375rem 0',
  gap: '60px'
});

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '1.875rem'
});
